import type { IconSvgObject } from './types';

const EarRings03Icon: IconSvgObject = [
  ["circle", { cx: "17", cy: "7", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "7", cy: "17", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 7H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 17H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M5 4.5C5.27522 2.92833 8 5.42371 8 7C8 8.57629 5.27522 11.0717 5 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M19 14.5C18.7248 12.9283 16 15.4237 16 17C16 18.5763 18.7248 21.0717 19 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default EarRings03Icon;
